import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { TranslatePipe } from '@ngx-translate/core';
import { DateFormatPipe } from '@rms/sdk/pipes';

import {
  PARTNER_USER_ACTION,
  PARTNER_USER_ROLE_LABELS,
  PARTNER_USER_STATUS,
  PARTNER_USER_STATUS_LABELS,
  PartnerUser,
} from '../../models';
import { PartnerUserActionsComponent } from '../partner-user-actions/partner-user-actions.component';
import { PARTNER_USER_ACTIONS, PartnerUserActionConfig } from '../partner-user-actions/partner-user-actions.config';

export interface PartnerUserActionEvent {
  user: PartnerUser;
  action: PARTNER_USER_ACTION;
}

@Component({
  selector: 'rms-partner-users-table',
  imports: [MatTableModule, TranslatePipe, DateFormatPipe, PartnerUserActionsComponent],
  templateUrl: './partner-users-table.component.html',
})
export class PartnerUsersTableComponent {
  @Input({ required: true }) public users: PartnerUser[] = [];
  @Input({ required: true }) public columns: string[] = [];
  @Input({ required: true }) public label = '';
  @Input() public actions: PartnerUserActionConfig[] = PARTNER_USER_ACTIONS;
  @Input() public signedInUserId: string | null = null;
  @Input() public signedInUserActions: PartnerUserActionConfig[] = [];
  @Input() public filtered = false;
  @Input() public deleting: Readonly<Record<string, boolean>> = {};
  @Input() public emptyMessage = 'partners.users.empty';
  @Output() public action = new EventEmitter<PartnerUserActionEvent>();

  protected readonly activeStatus = PARTNER_USER_STATUS.ACTIVE;
  protected readonly statusLabels: Readonly<Record<string, string>> = PARTNER_USER_STATUS_LABELS;
  protected readonly roleLabels: Readonly<Record<string, string>> = PARTNER_USER_ROLE_LABELS;
}
